import styled from 'styled-components';
import { getLocationHeroBackground } from './utils';
import { useSelector } from '@/redux';

/** With `onSelect` the hero is a button that opens the Select Location pop-up (TEAM-13315). */
type Props =
  | { onSelect: () => void; selectLabel: string; disabled?: boolean }
  | { onSelect?: undefined; selectLabel?: undefined; disabled?: undefined };

export const StoreHero = ({ onSelect, selectLabel, disabled }: Props = {}) => {
  const webConfig = useSelector((state) => state.app.cmsConfig.webConfig);
  const locationDetail = useSelector((state) => state.app.locations.detail);
  const background = getLocationHeroBackground(locationDetail, webConfig);

  if (!background) {
    return null;
  }

  const banner = <StoreBanner src={background} alt="Location hero image" />;

  if (!onSelect) {
    return banner;
  }

  return (
    <HeroButton
      type="button"
      data-testid="store-hero-select-location"
      aria-label={selectLabel}
      aria-haspopup="dialog"
      disabled={disabled}
      onClick={onSelect}
    >
      {banner}
    </HeroButton>
  );
};

const StoreBanner = styled.img(({ theme }) => ({
  backgroundColor: theme.store_detail.background_color ?? 'transparent',
  display: 'none',
  height: `${theme.store_detail.hero_height}px`,
  objectFit: 'cover',
  width: '100%',

  '@media (min-width: 768px)': {
    display: 'block',
  },
}));

// Hidden below 768px with the banner, so mobile gets no empty focusable control.
const HeroButton = styled.button({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  display: 'none',
  padding: 0,
  width: '100%',

  '@media (min-width: 768px)': {
    display: 'block',
  },

  '&:focus-visible': {
    outline: '2px solid currentColor',
    outlineOffset: '-4px',
  },

  '&:disabled': {
    cursor: 'not-allowed',
  },
});
